<template>
  <div
    class="skagen-consent-page-marketing alert alert-warning"
    v-if="initComplete"
  >
    <h2>{{ consentTexts.marketingHeading }}</h2>
    <div class="text--gdpr">
      <span v-html="consentTexts.marketingMainIntro"></span>
    </div>
    <div class="skagen-purpose-buttons">
      <button class="btn btn-primary" v-on:click="acceptMarketingConsent()">
        {{ consentTexts.marketingButtonText }}
      </button>
    </div>
  </div>
</template>
<script>
import { getConsent, saveConsent, isConsentGiven } from './consentUtil';
import {
  trackTradidionalGaEvent,
  EventInfoCategory,
  EventInfoAction,
} from '@/components/GoogleTagManager';
import { getConsentTexts } from '@/api/getConsentTexts';

export default {
  name: 'PageMarketingConsent',
  data() {
    return {
      initComplete: false,
      fetchError: false,
      consentTexts: {},
      consentData: {
        basic: true,
        useful: false,
        analytics: false,
        marketing: false,
      },
    };
  },
  created() {
    if (isConsentGiven()) {
      this.consentData = getConsent();
    }
    // fetch consent texts from backend
    this.fetchConsentData();
  },
  methods: {
    async fetchConsentData() {
      try {
        this.consentTexts = await getConsentTexts();
      } catch (err) {
        this.fetchError = true;
      } finally {
        this.initComplete = true;
      }
    },
    acceptMarketingConsent() {
      this.consentData.marketing = true;
      saveConsent(this.consentData);
      trackTradidionalGaEvent(
        EventInfoCategory.Consent,
        EventInfoAction.Button,
        'acceptMarketingInYoutubeView'
      );
      // This will tell parent component that consent is accepted and content can be visible for user
      this.$emit('consent:acceptMarketing');
    },
  },
};
</script>
<style>
.skagen-consent-page-marketing h2 {
  margin-top: 0;
}

.skagen-consent-page-marketing.text--gdpr {
  margin-bottom: 20px;
}

.skagen-consent-page-marketing .text--gdpr p {
  font-size: 19px;
  color: #707070;

  @media (max-width: 480px) {
    margin-bottom: 30px;
  }
}
.skagen-consent-page-marketing .skagen-purpose-buttons {
  margin-top: 30px;
}
</style>
